import {
	AutocompleteInput,
	Create,
	ReferenceInput,
	SimpleForm,
	required,
} from "react-admin";
import { useCreateSubmit } from "../../forms";
import { userName } from "../users/userName";

export const TeamUserCreate = () => {
	const submit = useCreateSubmit("team-users", "User assigned to team", {
		resource: "teams",
		idColumn: "team_id",
		view: "show",
	});

	return (
		<Create title="Assign user to team">
			<SimpleForm onSubmit={submit}>
				<ReferenceInput source="team_id" reference="teams">
					<AutocompleteInput
						validate={required()}
						optionText="name"
						fullWidth
						disabled
					/>
				</ReferenceInput>
				<ReferenceInput source="user_id" reference="users">
					<AutocompleteInput
						validate={required()}
						optionText={userName}
						fullWidth
					/>
				</ReferenceInput>
				<ReferenceInput source="role_id" reference="roles">
					<AutocompleteInput
						optionText="name"
						fullWidth
						validate={required()}
					/>
				</ReferenceInput>
			</SimpleForm>
		</Create>
	);
};
